<div class="hero-container">
    <div class="hero-me me" id="media-engine-hero"></div>
    <section class="title-and-ctas">
        <ng-container *ngIf="isMobile">
            <h1 *ngIf="titleMobile"
                class="cta-title"
                [innerHTML]="titleMobile | safeHtml">
            </h1>
            <section class="ctas">
                <div class="ctas-holder">
                    <a *ngIf="hasFirstCTA"
                        class="cta first-cta play-full-video"
                        aria-hidden="false"
                        name="&lid={{mobileVideoFirstCTA?.['analyticsLinkId']}}"
                        title="{{mobileVideoFirstCTA?.['alt']}}"
                        tabindex="0"
                        (click)="enterFullscreen($event)"
                    >
                        {{mobileVideoFirstCTA?.['title']}}
                        <span class="icon" aria-hidden="true"></span>
                    </a>
                    <a class="cta details-cta"
                        href="{{mobileVideoDetailsCTA?.['ctaURL'] | absTrimmer:true:true}}"
                        name="&lid={{mobileVideoDetailsCTA?.['analyticsLinkId']}}"
                        title="{{mobileVideoDetailsCTA?.['alt']}}"
                        target="{{mobileVideoDetailsCTA?.['target']}}"
                        tabindex="0"
                        aria-hidden="false"
                    >
                        {{mobileVideoDetailsCTA?.['title']}}
                        <span class="icon" aria-hidden="true"></span>
                    </a>
                </div>
            </section>
        </ng-container>

        <ng-container *ngIf="!isMobile">
            <h1 *ngIf="titleDesktop"
                class="cta-title"
                [innerHTML]="titleDesktop | safeHtml"></h1>
            <section class="ctas">
                <div class="ctas-holder">
                    <a *ngIf="hasFirstCTA"
                        class="cta first-cta play-full-video"
                        name="&lid={{videoFirstCTA?.['analyticsLinkId']}}"
                        title="{{videoFirstCTA?.['alt']}}"
                        (click)="enterFullscreen($event)"
                        tabindex="0"
                        aria-hidden="false"
                    >
                        {{videoFirstCTA?.['title']}}
                        <span class="icon" aria-hidden="true"></span>
                    </a>
                    <a
                        class="cta details-cta"
                        href="{{videoDetailsCTA?.['ctaURL'] | absTrimmer:true:true}}"
                        name="&lid={{videoDetailsCTA?.['analyticsLinkId']}}"
                        title="{{videoDetailsCTA?.['alt']}}"
                        target="{{videoDetailsCTA?.['target']}}"
                        tabindex="0"
                        aria-hidden="false"
                    >
                        {{videoDetailsCTA?.['title']}}
                        <span class="icon" aria-hidden="true"></span>
                    </a>
                </div>
            </section>
        </ng-container>
    </section>
</div>
